import { Injectable } from '@angular/core';
import { environment } from 'src/environment/environment';
import { TokenService } from '../../../shared/services/token.service';
import { isPreviewableDocument } from '../animal-details-documents/document-file-type.util';
import { MedicalFile } from '../states/medical/animal-medical.selectors';

/** URL-Aufbau und Download für Karteikarten-Anhänge, wie in Dokumente und Mediathek. */
@Injectable({ providedIn: 'root' })
export class MedicalFileService {
  constructor(private readonly _tokenService: TokenService) {}

  /** Authentifizierte URL für `<iframe>` bzw. Download. */
  fileUrl(file: MedicalFile): string | null {
    const path = file.kind === 'document' ? file.document?.downloadUrl : file.media?.contentUrl;
    if (!path) return null;
    const origin = environment.apiUrl.replace(/\/api\/?$/, '');
    const token = this._tokenService.getAccessToken();
    const url = `${origin}${path}`;
    return token ? `${url}?x-auth-token=${encodeURIComponent(token)}` : url;
  }

  isPreviewableDocument(file: MedicalFile): boolean {
    return file.kind === 'document' && isPreviewableDocument(file.document?.filePath ?? file.name);
  }

  async download(file: MedicalFile): Promise<void> {
    const url = this.fileUrl(file);
    const token = this._tokenService.getAccessToken();
    if (!url || !token) return;

    try {
      const response = await fetch(url, { headers: { 'x-auth-token': token } });
      if (!response.ok) throw new Error('Download fehlgeschlagen');
      const blob = await response.blob();

      const a = window.document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = file.name;
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    } catch (e) {
      console.error('Download fehlgeschlagen', e);
    }
  }
}
